// extracted by mini-css-extract-plugin
export default {"container":"Tints_container__vOlUR","wrap":"Tints_wrap__HRzE9","tint":"Tints_tint__IZW5y","color":"Tints_color__kqLpS","label":"Tints_label__Zc8QX"};